/**
 *
 * @module deviceMetadata
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString,
    object
} = Check.assert;

/**
 *
 * @class DeviceMetadata
 * @desc A semi-structured data type, containing a few mandatory fields, but
 * allowing a number of arbitrary key -> string to be added at the top level of the structure.
 *
 */
export default class DeviceMetadata {

    /**
     *
     * @param {String} deviceFamily
     * @param {String} applicationRuntime
     * @param {String} deviceProfile
     * @param {Object} [extraData=null]
     * @throws {InvalidArgumentException}
     *
     */
    constructor(deviceFamily, applicationRuntime, deviceProfile, extraData = null) {

        const errorMessage = {
            ctor: 'DeviceMetadata(deviceFamily, applicationRuntime, deviceProfile, extraData)',
            get deviceFamily() {
                return `${this.ctor} deviceFamily should be a String with length`;
            },
            get applicationRuntime() {
                return `${this.ctor} applicationRuntime should be a String with length`;
            },
            get deviceProfile() {
                return `${this.ctor} deviceProfile should be a String with length`;
            },
            get extraData() {
                return `${this.ctor} extraData should be a plain Object`;
            }
        };

        nonEmptyString(deviceFamily, errorMessage.deviceFamily, InvalidArgumentException);
        nonEmptyString(applicationRuntime, errorMessage.applicationRuntime, InvalidArgumentException);
        nonEmptyString(deviceProfile, errorMessage.deviceProfile, InvalidArgumentException);

        if (Check.assigned(extraData)) {
            object(extraData, errorMessage.extraData, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets the device family (like android, apple, browser, microsoft, roku).
         *
         */
        this.deviceFamily = deviceFamily;

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets the runtime (for example OS) for the device.
         *
         */
        this.applicationRuntime = applicationRuntime;

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets the concrete hardware or browser.
         *
         */
        this.deviceProfile = deviceProfile;

        /**
         *
         * @access public
         * @type {Object}
         * @desc Gets a map of String -> String for additional properties.
         *
         */
        this.extraData = extraData || {};

    }

}



// WEBPACK FOOTER //
// ./src/services/device/deviceMetadata.js